// extracted by mini-css-extract-plugin
module.exports = {"sm":"576","md":"860","pccFullSize":"780","lg":"1024","xl":"1280"};